import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../constants/url";

type CommonResponseType = {
  statusCode: number;
  message: string;
};

type CommonBody = {
  statusCode: number;
  message: string;
};

export const authApi: any = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postLogIn: builder.mutation<
      CommonResponseType & { data: User },
      CommonBody //is here
    >({
      query: (body) => ({
        url: END_POINTS.login,
        // url: "",
        method: "POST",
        body,
      }),
    }),
    getUser: builder.query<CommonResponseType & { data: User }, {}>({
      query: () => ({
        url: END_POINTS.get_user,
        method: "GET",
      }),
    }),
    postLogout: builder.mutation<CommonResponseType, {}>({
      query: () => ({
        url: END_POINTS.logout,
        method: "POST",
      }),
    }),
    forgotPassword: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.forgotPassword,
        method: "POST",
        body,
      }),
    }),
    postVerifyOtp: builder.mutation<
      CommonResponseType & { data: User },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.verifyOtp,
        method: "POST",
        body,
      }),
    }),
    resetPassword: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.verifyOtp,
        method: "POST",
        body,
      }),
    }),
    putUpdateProfile: builder.mutation<
      CommonResponseType & { data: updateProfile },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.get_user,
        method: "PUT",
        body,
      }),
    }),
    postChangePassword: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.changePassword,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  usePostLogInMutation,
  useForgotPasswordMutation,
  usePostVerifyOtpMutation,
  useResetPasswordMutation,
  useLazyGetUserQuery,
  useGetUserQuery,
  usePostLogoutMutation,
  usePostChangePasswordMutation,
  usePutUpdateProfileMutation,
} = authApi;
